"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Eunice = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SelectCard_1 = require("../../inputs/SelectCard");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const Resources_1 = require("../../Resources");
class Eunice extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.EUNICE,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L38',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().text('ACTIVATE THE BELOW ABILITY');
                    b.br.br;
                    b.megacredits(-12).colon().text('COPY').prelude().any.megacredits(3).multiplier.asterix();
                    b.br.br;
                }),
                description: 'Once per game, pay 12 M€ to copy the direct effect of any prelude in play. Then gain 3X M€, where X is the current generation number.',
            },
        });
        this.isDisabled = false;
        this.opgActionIsActive = false;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        return player.canAfford(12) && this.isDisabled === false;
    }
    action(player) {
        const game = player.game;
        game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 12));
        const allPlayedPreludes = game.getPlayers().map((player) => player.playedCards.filter((c) => c.cardType === CardType_1.CardType.PRELUDE)).reduce((a, b) => a.concat(b));
        let eligiblePreludes = allPlayedPreludes.filter((c) => c.canPlay === undefined || c.canPlay(player));
        eligiblePreludes = eligiblePreludes.filter((value, index, arr) => arr.findIndex(v2 => (v2.name === value.name)) === index);
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            this.opgActionIsActive = true;
            return undefined;
        }));
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            return new SelectCard_1.SelectCard('Choose prelude card to copy', 'Select', eligiblePreludes, (foundCards) => {
                game.defer(new DeferredAction_1.DeferredAction(player, () => foundCards[0].play(player)));
                game.log('${0} copied ${1} effect', (b) => b.player(player).card(foundCards[0]));
                return undefined;
            });
        }));
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            player.addResource(Resources_1.Resources.MEGACREDITS, game.generation * 3);
            return undefined;
        }));
        this.isDisabled = true;
        return undefined;
    }
}
exports.Eunice = Eunice;
//# sourceMappingURL=Eunice.js.map